import { useEffect, useState } from 'react'

const STANDALONE_QUERY = '(display-mode: standalone)'

function detectIsPwa(): boolean {
  if (typeof window === 'undefined') return false
  const nav = window.navigator as Navigator & { standalone?: boolean }
  if (nav.standalone === true) return true
  return window.matchMedia(STANDALONE_QUERY).matches
}

export function useIsPwa(): boolean {
  const [isPwa, setIsPwa] = useState(false)

  useEffect(() => {
    const update = () => {
      setIsPwa(detectIsPwa())
    }

    update()

    const mediaQuery = window.matchMedia(STANDALONE_QUERY)
    mediaQuery.addEventListener('change', update)

    return () => {
      mediaQuery.removeEventListener('change', update)
    }
  }, [])

  return isPwa
}
